import React, { useEffect, useState } from "react";
import { Button, Tags } from "../ui";
import LudDashboardModal from "./LudDashboardModal";
import { useSubmitGuard } from "./modalHooks";
import "./BranchIntegrationStatusModal.css";

const STATUS_OPTIONS = [
  {
    value: "active",
    labelAr: "نشط",
    labelEn: "Active",
    variant: "success",
  },
  {
    value: "inProgress",
    labelAr: "جاري العمل",
    labelEn: "In Progress",
    variant: "warning",
  },
  {
    value: "inactive",
    labelAr: "غير نشط",
    labelEn: "Inactive",
    variant: "danger",
    appearance: "filled",
  },
];

export default function BranchIntegrationStatusModal({
  open,
  lang,
  branch,
  onClose,
  onSave,
}) {
  // Repeat clicks are ignored while a save returned by the caller is running.
  const [saving, runSave] = useSubmitGuard();
  const [status, setStatus] = useState("inactive");

  useEffect(() => {
    if (!open) return;

    setStatus(branch?.integrationStatus || "inactive");
    // Initialise when the modal opens or the entity changes, not whenever the
    // parent passes a new object/array for the same data (that wiped edits).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, branch?.id]);

  return (
    <LudDashboardModal
      open={open}
      busy={saving}
      title={
        lang === "ar"
          ? `تغيير حالة التكامل — ${branch?.nameAr || ""}`
          : `Change Integration Status — ${branch?.nameEn || ""}`
      }
      onClose={onClose}
      footer={
        <>
          <Button
            variant="primary"
            appearance="filled"
            onClick={() => runSave(onSave, status)}
            disabled={saving}
            loading={saving}
          >
            {lang === "ar" ? "حفظ" : "Save"}
          </Button>

          <Button
            variant="danger"
            appearance="soft"
            onClick={onClose}
          >
            {lang === "ar" ? "إلغاء" : "Cancel"}
          </Button>
        </>
      }
    >
      <div className="branch-integration-status-options">
        {STATUS_OPTIONS.map((option) => (
          <button
            key={option.value}
            type="button"
            className={
              status === option.value ? "selected" : ""
            }
            onClick={() => setStatus(option.value)}
          >
            <Tags
              variant={option.variant}
              appearance={option.appearance || "soft"}
              size="sm"
            >
              {lang === "ar"
                ? option.labelAr
                : option.labelEn}
            </Tags>
          </button>
        ))}
      </div>
    </LudDashboardModal>
  );
}
